export default __webpack_public_path__ + "static/media/majorelle-mix.90b8484a.jpg";